export default "__VITE_ASSET__iCQ43n1v__"